
import {
    LAWYERS_BY_REGION
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case LAWYERS_BY_REGION:
        return action.payload
      default:
        return state
    }
  }
